<template>
	<div>
		<!-- Greetings Dialog -->
        <modal
			wrapper="full"
			size="full"
			class="template-modal gallery-modal"
			:hide-footer="true"
			@close="close">
            <template slot="body">
			<div @click="close"  class="modal-close-media-template">
				<i class="material-icons font15">close</i>
			</div>
			<div class="row mt-5 pt-3">
				<div class="col-lg-8" v-if="valueUrl.length === 0 && Array.isArray(valueUrl)">
					<img src="/img/Grafias-onBlackHD.png" alt="xls" width="100%"/>
				</div>
				<div class="col-lg-8" v-if="!Array.isArray(valueUrl) && !isNdiInput">
					<img :src="safeRuleThird" alt="Grafias" style="pointer-events: none; padding-left:15px; padding-right:15px;" class="absolute z-index-99 min-w-100">
					<iframe id="iframePreview"
					frameborder="0"
					:style="{ width:'100%', height: '100%'}"
					allow="accelerometer; autoplay; encrypted-media;"
					allowfullscreen
					:src="convertURL(valueUrl.label)">
					</iframe>
				</div>
				<div class="col-lg-8" v-show="!Array.isArray(valueUrl) && isNdiInput">
					<img :src="safeRuleThird" alt="Grafias" style="pointer-events: none; padding-left:15px; padding-right:15px;" class="absolute z-index-99 min-w-100">
					<video
						id="iframePreview"
						:muted="false"
						:style="{ width:'100%', height: '100%'}"
						autoplay
						scrolling="no"
						ref="videoInput">
					</video>
				</div>
				<div class="col-lg-4">
					<h5 class="text-white mb-3">{{ $t('Add Virtual Cam ') }} </h5>
					<div>
						<label class="text-grey">{{ $t('Select Input Device or add URL') }} </label>
						<div class="form-group rundown-collab mt-2 mb-2">
							<multiselect class="rundown-collab-input" v-model="valueUrl" tag-placeholder="Add this as new url"
								placeholder="Search device or add URL" label="label" track-by="label" :allow-empty="false"
								deselect-label="" @select="onSelect" @tag="addTag"
								:options="videoOptions" :multiple="false" :taggable="true" >
								<span class="arrow-multiselect" slot="caret">
									<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
								</span>
							</multiselect>
						</div>
					</div>
					<span class="text-small text-red" v-if="listUrl.includes(valueUrl.label) || listUrl.includes(valueUrl.deviceId)">{{$t('The URL already exists, you have entered this url')}} </span>
					<!-- radio button group -->
					<div class="d-flex mt-3">
						<md-switch
							class="md-primary mt-0 mb-3 mr-4"
							v-model="isHideLabel">
							{{ $t('Hide Label') }}
						</md-switch>
						<md-switch
							class="md-primary mt-0 mb-3 mr-4"
							v-model="isEmptyFeed">
							{{ $t('Empty Feed') }}
						</md-switch>
					</div>
					<!-- label -->
					<div>
						<label class="text-grey">{{ $t('Heading Label') }} </label>
						<custom-input
							class="mb-3"
							align="left"
							v-model="headingLabel"
						/>
					</div>
					<div>
						<label class="text-grey">{{ $t('Sub Heading Label') }} </label>
						<custom-input
							class="mb-3"
							align="left"
							v-model="subHeadingLabel"
						/>
					</div>
					<!-- size -->
					<div class="d-flex">
						<div class="mw-84">
							<label class="text-grey">{{ $t('Width') }} </label>
							<custom-input
								type="number"
								:min="0"
								:max="9999"
								:step="10"
								class="mb-3"
								align="left"
								v-model="width"
							/>
						</div>
						<div class="ml-4 mw-84">
							<label class="text-grey">{{ $t('Height') }} </label>
							<custom-input
								type="number"
								:min="0"
								:max="9999"
								:step="10"
								class="mb-3"
								align="left"
								v-model="height"
							/>
						</div>
					</div>
					<!-- css form -->
					<!-- <div class="d-flex justify-content-between ml-0 pl-0">
						<label class="text-grey">{{ $t('Custom CSS') }} </label>
						<i class="material-icons icon-help-outline pointer" v-tooltip.bottom-end="$t('Custom CSS')">help_outline</i>
					</div>
					<textarea class="textarea-css" rows="8" v-model="customCss">  </textarea> -->
					<!-- button action -->
					<div class="d-flex justify-content-between">
						<div class="d-flex">
							<button type="button"
								:disabled="listUrl.includes(valueUrl.label) || !isFormValid || listUrl.includes(valueUrl.deviceId)"
								v-if="!virtualCam"
								@click="addVirtualCam"
								class="btn btn-primary">Add
							</button>
							<button type="button"
								:disabled="listUrl.includes(valueUrl.label) && !isFormValid  || listUrl.includes(valueUrl.deviceId) && !isFormValid"
								v-if="virtualCam"
								@click="updateVirtualCam"
								class="btn btn-primary">Update
							</button>
							<button type="button"
								@click="close"
								class="btn btn-default ml-3">Cancel
							</button>
						</div>
						<div>
							<button type="button"
								@click="refresh()"
								class="btn btn-primary btn-icon pr-0 mr-0">
								<i class="material-icons">refresh</i>
							</button>
						</div>
					</div>
				</div>
			</div>
			</template>
            <div slot="footer" class="text-center">
            </div>
		</modal>
	</div>
</template>

<script>

import RTC from 'detectrtc';
import Multiselect from 'vue-multiselect';
import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import CustomInput from '@/components/CustomInput.vue';

export default {
	name: 'ModalVirtualCam',
	components: {
		Modal,
		CustomInput,
		Multiselect,
	},
	props: {
		virtualCams: {
			type: Array,
		},
		virtualCam: {
			type: Object,
		},
	},
	mounted() {
		this.initDevices();
	},
	created() {
		this.initData();
		this.gettingUrlList();
	},
	data: () => ({
		valueUrl: [],
		isEmptyFeed: false,
		isHideLabel: true,
		isSoloVideo: true,
		isMute: false,
		isPower: true,
		headingLabel: '',
		subHeadingLabel: '',
		width: 1920,
		height: 1080,
		customCss: '',
		listUrl: [],
		order: 1,
		id: 0,
		videoOptions: [],
		localStream: null,
		safeRuleThird: '/img/safe_rule_third.png',
	}),
	beforeDestroy() {
		this.stopStream();
	},
	methods: {
		convertURL(url) {
			let resultUrl = url;
			// check youtube only
			if (resultUrl.includes('https://www.youtu') || resultUrl.includes('https://youtu')) {
				const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
				const match = resultUrl.match(regExp);
				// eslint-disable-next-line
				if (match && match[2].length == 11) {
					return `https://www.youtube.com/embed/${match[2]}?autoplay=1`;
				}
			}
			// check vimeo only
			if (resultUrl.includes('https://vimeo')) {
				const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
				const match = resultUrl.match(regExp);
				// eslint-disable-next-line
				if (match) {
					return `https://player.vimeo.com/video/${match[5]}?autoplay=1`;
				}
				return 'error';
			}
			if (resultUrl.includes('https://player.vimeo')) resultUrl = `${resultUrl}?autoplay=1`;
			return resultUrl;
		},
		onSelect(selectedItem) {
			if (selectedItem && selectedItem.deviceId) {
				if (!this.localStream) {
					// console.log(selectedItem.deviceId);
					this.playVideo(selectedItem.deviceId);
				} else {
					this.stopStream();
					this.playVideo(selectedItem.deviceId);
				}
			}
		},
		addTag(newTag) {
			const tag = {
				label: newTag,
			};
			this.videoOptions.push(tag);
			this.valueUrl = tag;
		},
		stopStream() {
			if (this.localStream) {
				this.localStream.getTracks().forEach((track) => {
					track.stop();
				});
			}
		},
		playVideo(deviceId) {
			// console.log(deviceId);
			navigator.mediaDevices.getUserMedia({
				video: {
					deviceId: { exact: deviceId },
				},
				audio: true,
			}).then((stream) => {
				this.localStream = stream;
				if (this.$refs.videoInput) this.$refs.videoInput.srcObject = stream;
			}).catch(() => {
				// console.log(err);
			});
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.virtualCam) {
				this.setData(this.virtualCam);
			}
		},
		refresh() {
			document.getElementById('iframePreview').src = document.getElementById('iframePreview').src;
		},
		reset() {
			this.id = this.virtualCams && this.virtualCams.length > 0 ? this.virtualCams.length : 0;
			this.valueUrl = [];
			this.isEmptyFeed = false;
			this.isHideLabel = false;
			this.isSoloVideo = false;
			this.isMute = false;
			this.headingLabel = '';
			this.subHeadingLabel = '';
			this.width = 1920;
			this.height = 1080;
			this.customCss = '';
			this.order = 1;
			this.isPower = true;
		},
		setData(virtualCam) {
			this.id = virtualCam.id || 0;
			if (!virtualCam.url.includes('http')) {
				const indexVideo = this.videoOptions.findIndex(({ deviceId }) => deviceId === virtualCam.url);
				if (indexVideo !== -1) {
					this.valueUrl = this.videoOptions[indexVideo];
					this.playVideo(this.valueUrl.deviceId);
				} else {
					this.valueUrl = {
						label: virtualCam.url,
					};
				}
			} else {
				this.valueUrl = {
					label: virtualCam.url,
				};
			}
			this.isEmptyFeed = virtualCam.is_empty_feed;
			this.isHideLabel = virtualCam.is_hide_label;
			this.isSoloVideo = virtualCam.is_solo_video;
			this.isMute = virtualCam.is_mute;
			this.headingLabel = virtualCam.heading;
			this.subHeadingLabel = virtualCam.sub_heading;
			this.width = virtualCam.width;
			this.height = virtualCam.height;
			this.customCss = virtualCam.custom_css;
			this.order = virtualCam.order;
			this.isPower = virtualCam.is_power && virtualCam.is_power === undefined ? true : virtualCam.is_power;
		},
		gettingUrlList() {
			if (this.virtualCams.length !== 0) {
				for (let index = 0; index < this.virtualCams.length; index++) {
					const element = this.virtualCams[index];
					this.listUrl.push(element.url);
				}
			}
			if (this.virtualCam) {
				const index = this.listUrl.indexOf(this.virtualCam.url);
				if (index !== -1) {
					this.listUrl.splice(index, 1);
				}
			}
			return this.listUrl;
		},
		addVirtualCam() {
			const virtualCam = {
				id: Date.now().toString(36) + Math.random().toString(36).substr(2),
				heading: this.headingLabel,
				sub_heading: this.subHeadingLabel,
				is_empty_feed: this.isEmptyFeed,
				is_hide_label: this.isHideLabel,
				is_solo_video: this.isSoloVideo,
				is_power: this.isPower,
				is_mute: this.isMute,
				width: this.width,
				height: this.height,
				custom_css: this.customCss,
				order: this.virtualCams.length + 1,
				is_ndi: this.isNdiInput,
			};
			if (!this.valueUrl.deviceId) {
				virtualCam.url = this.valueUrl.label;
			} else {
				virtualCam.url = this.valueUrl.deviceId;
			}
			this.$emit('addVirtualCam', virtualCam);
			this.valueUrl = [];
		},
		reorder(vCamItems) {
			const items = [];
			for (let index = 0; index < vCamItems.length; index++) {
				items.push(vCamItems[index]);
				items[index].order = index + 1;
			}
			return items;
		},
		updateVirtualCam() {
			const virtualCam = {
				id: this.virtualCam.id,
				heading: this.headingLabel,
				sub_heading: this.subHeadingLabel,
				is_empty_feed: this.isEmptyFeed,
				is_hide_label: this.isHideLabel,
				is_solo_video: this.isSoloVideo,
				is_power: this.isPower,
				is_mute: this.isMute,
				width: this.width,
				height: this.height,
				custom_css: this.customCss,
				is_ndi: this.isNdiInput,
			};
			if (!this.valueUrl.deviceId) {
				virtualCam.url = this.valueUrl.label;
			} else {
				virtualCam.url = this.valueUrl.deviceId;
			}
			const virtualCams = this.virtualCams.slice();
			const index = virtualCams.findIndex(({ id }) => id === this.virtualCam.id);
			this.$set(virtualCams, index, virtualCam);
			this.$emit('updateVirtualCam', this.reorder(virtualCams));
		},
		initDevices() {
			RTC.load(() => {
				RTC.MediaDevices.map((device) => {
					if (device.kind === 'videoinput') {
						this.videoOptions.push(device);
					}
					return device;
				});
				this.initData();
			});
		},
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'isLoggedIn',
			user: 'user',
		}),
		isFormValid() {
			return this.valueUrl !== ''
			&& this.headingLabel !== '';
		},
		isNdiInput() {
			let isNdi = false;
			if (this.valueUrl && this.valueUrl.label) {
				isNdi = this.valueUrl.label !== '' && !this.valueUrl.label.includes('http');
			}
			return isNdi;
		},
	},

};
</script>

<style lang="scss" scoped>
</style>
